/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import React, { useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core'
import { LanguageHelp, getConfig, isAllFilter } from '../../../_metronic/helpers/LanguageHelper'
import {
  ChartsWidget1,
  ChartsWidget1Dto,
  ChartsWidgetLine,
  ChartsWidgetLineDto,
  TablesWidget5,
  ListsWidget6,
  CardsWidget17,
  CardsWidget17Dto,
  TablesWidget5Dto,
  ListsWidget6Dto,
  WordCloud,
  WordCloudDto,
  TablesWidget14,
  TablesWidget14Dto,
  TablesWidget15,
  TablesWidget15Dto,
  ChartsWidgetBubble,
  ChartsWidget2,
  ChartsWidgetTreeDto,
  ChartsWidgetTree,
  ChartsWidget2Dto,
  ChartsWidgetBubbleDto,
  AttributesDto,
  ChartsWidgetWorldMap,
  ChartsWidgetWorldMapDto,
  ChartsWidgetLanguageBar,
  ChartsWidgetLanguageBarDto,
} from '../../../_metronic/partials/widgets'
import * as requests from './_requests'
import { getColorCodeFromDivision } from '../../../_metronic/helpers/utility';
import { CardsWidget18, CardsWidget18Dto } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget18';
import { DropdownFilterCompetitor } from '../../../_metronic/partials/content/dropdown/DropdownFilterCompetitor';
import { DropdownFilterChannels } from '../../../_metronic/partials/content/dropdown/DropdownFilterChannels';
import { DropdownFilterSubject } from '../../../_metronic/partials/content/dropdown/DropdownFilterSubject';
import { DropdownFilterTag } from '../../../_metronic/partials/content/dropdown/DropdownFilterTag';
import { DropdownFilterDate } from '../../../_metronic/partials/content/dropdown/DropdownFilterDate';
import { DropdownFilterMinCount } from '../../../_metronic/partials/content/dropdown/DropdownFilterMinCount';
import { DropdownFilterSourceType, sourceTypeFilterDefaultKey } from '../../../_metronic/partials/content/dropdown/DropdownFilterSourceType';
import * as authHelper from '../../../app/modules/auth/core/AuthHelpers';
import { DropdownFilterAnalysisLevel } from '../../../_metronic/partials/content/dropdown/DropdownFilterAnalysisLevel';
import { DropdownFilterLanguage } from '../../../_metronic/partials/content/dropdown/DropdownFilterLanguage';
import { DropdownFilterCountry } from '../../../_metronic/partials/content/dropdown/DropdownFilterCountry';
import { toLanguageOptions, toCountryOptions, GeoLanguageCountryOption } from '../../../_metronic/helpers/GeoLanguageHelper';

// import {AuthModel} from './../../modules/auth/core/_models'
const DashboardWrapper: FC = () => {
  const [reviewSubjects, updateReviewSubjects] = React.useState([]);
  const [reviewTags, updateReviewTags] = React.useState([]);
  const [reviewSubjectGroups, setReviewSubjectGroups] = useState<[]>([]);
  const [overallSentimentDistribution, updateOverallSentimentDistribution] = React.useState(new CardsWidget17Dto());
  const [yourSentimentDistribution, updateYourSentimentDistribution] = React.useState(new CardsWidget17Dto());
  const [competitorSentimentDistribution, updateCompetitorSentimentDistribution] = React.useState(new CardsWidget17Dto());
  const [competitionVolumeDistribution, updateCompetitionVolumeDistribution] = React.useState(new CardsWidget18Dto());
  const [channels, updateChannel] = React.useState(new TablesWidget5Dto());
  const [competitors, updateCompetitors] = React.useState([]);
  const [sentimentByMonths, updateTestSentimentCountByMonths] = React.useState([new ChartsWidget1Dto()]);
  const [sentimentByCompetitors, updateTestSentimentCountByCompetitors] = React.useState([new ChartsWidget1Dto()]);
  const [sentimentByCompetitorsAndSubjects, updateSentimentByCompetitorsAndSubject] = React.useState([new ChartsWidgetBubbleDto()]);
  const [sentimentByPlatforms, updateTestSentimentCountByPlatforms] = React.useState([new ChartsWidget1Dto()]);
  const [sentimentByDays, updateTestSentimentCountByDays] = React.useState([new ChartsWidgetLineDto()]);
  const [notifications, updateNotification] = React.useState([new ListsWidget6Dto()]);
  // const [tokensForWordCloud, updateTokenForWordCloud] = React.useState([new WordCloudDto()]);
  // const [tokensForTable, updateTokenForTable] = React.useState(new TablesWidget14Dto());
  const [subjectSentimentsForWordCloud, updateSubjectSentimentForWordCloud] = React.useState([new WordCloudDto()]);
  const [subjectSentimentsForTable, updateSubjectSentimentForTable] = React.useState(new TablesWidget14Dto());
  const [subjectSentimentCompetitionsForTable, updateSubjectSentimentCompetitionForTable] = React.useState(new TablesWidget15Dto());
  const [subjectGroupSentimentCompetitionsForTable, updateSubjectGroupSentimentCompetitionForTable] = React.useState(new TablesWidget15Dto());
  const [hashtagsForWordCloud, updateHashtagForWordCloud] = React.useState([new WordCloudDto()]);
  const [hashtagsForTable, updateHashtagForTable] = React.useState(new TablesWidget14Dto());
  const [subjectTree, updateSubjectTree] = React.useState([new ChartsWidgetTreeDto()]);
  const [countryMapData, updateCountryMapData] = React.useState<ChartsWidgetWorldMapDto[]>([]);
  const [languageBarData, updateLanguageBarData] = React.useState<ChartsWidgetLanguageBarDto[]>([]);


  const [isFilterCompleted, updateIsFilterCompleted] = React.useState("false");
  const [filter_Date, updateFilter_Date] = React.useState(LanguageHelp('Last 30 days'));
  const [filter_Subject, updateFilter_Subject] = React.useState(LanguageHelp('All Subjects'));
  const [filter_Tag, updateFilter_Tag] = React.useState(LanguageHelp('All Tags'));
  const [filter_MinCount, updateFilter_MinCount] = React.useState('5');
  // Channel dropdown submits English keys (e.g. "All Platforms"); keep state as key for stable API/UI checks.
  const [filter_ChannelType, updateFilter_ChannelType] = React.useState('All Platforms');
  const [filter_Competitor, updateFilter_Competitor] = React.useState(LanguageHelp('All Competitors'));
  const [filter_SourceType, updateFilter_SourceType] = React.useState(sourceTypeFilterDefaultKey);
  const [filter_AnalysisLevel, updateFilter_AnalysisLevel] = React.useState(LanguageHelp('Sharing Based'));
  const [filter_Language, updateFilter_Language] = React.useState('');
  const [filter_Country, updateFilter_Country] = React.useState('');
  const [languageOptions, setLanguageOptions] = React.useState<GeoLanguageCountryOption[]>([]);
  const [countryOptions, setCountryOptions] = React.useState<GeoLanguageCountryOption[]>([]);

  const getCompetitorNames = async () => {
    const _data = await requests.GetCompetitorNames()
    _data.unshift(LanguageHelp('All Competitors'))
    updateCompetitors(_data);
  }

  const getReviewSubjects = async () => {
    const _data = await requests.GetReviewSubjects()
    _data.unshift(LanguageHelp('All Subjects'))
    updateReviewSubjects(_data);
  }

  const getReviewTags = async () => {
    const _data = await requests.GetReviewTagsForSelect2()
    // const _data = await requests.GetReviewTags()

    _data.unshift({ value: '', label: LanguageHelp('All Tags'), isParent: true })
    updateReviewTags(_data);
  }

  const getReviewSubjectGroups = async () => {
    try {
      const _data = await requests.GetReviewSubjectGroupsForSelect2(true)
      localStorage.setItem("ReviewSubjectGroups_Parents", JSON.stringify(_data))
      setReviewSubjectGroups(_data);
    } catch (error) {
      console.error(error)
    }
  }

  const updateOverallSentimentDistributionFunction = async (sourceType: string, date: string, subject: string, tag: string, channelType: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetSentimentDistribution(sourceType, date, subject, tag, channelType, "OverallCompetitors", analysisLevel, filterLanguage, filterCountry)
    updateOverallSentimentDistribution(_data);
  }

  const updateYourSentimentDistributionFunction = async (sourceType: string, date: string, subject: string, tag: string, channelType: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetSentimentDistribution(sourceType, date, subject, tag, channelType, "We", analysisLevel, filterLanguage, filterCountry)
    updateYourSentimentDistribution(_data);
  }

  const updateCompetitorSentimentDistributionFunction = async (sourceType: string, date: string, subject: string, tag: string, competitor: string, channelType: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetSentimentDistribution(sourceType, date, subject, tag, channelType, competitor, analysisLevel, filterLanguage, filterCountry)
    updateCompetitorSentimentDistribution(_data);
  }

  const updateCompetitionVolumeDistributionFunction = async (sourceType: string, date: string, subject: string, tag: string, channelType: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetCompetitionVolumeDistribution(sourceType, date, subject, tag, channelType, analysisLevel, filterLanguage, filterCountry)
    updateCompetitionVolumeDistribution(_data);
  }

  const updateChannelFunction = async (sourceType: string, date: string, subject: string, tag: string, channelType: string, competitor: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetTestSentimentRateByChannels(sourceType, date, subject, tag, channelType, competitor, analysisLevel, filterLanguage, filterCountry)
    updateChannel(_data);
  }

  const [isDownloadContinue_TestSentimentRateByChannels, updateIsDownloadContinue_TestSentimentRateByChannels] = React.useState(false);
  const downlodTestSentimentRateByChannels = async () => {
    try {
      updateIsDownloadContinue_TestSentimentRateByChannels(true)
      const _data = await requests.DownloadTestSentimentRateByChannels()
      updateIsDownloadContinue_TestSentimentRateByChannels(false)
    } catch (error) {
      console.error(error)
    }
  }

  const [isDownloadContinue_TestCountBySentimentAndCompetitor, updateIsDownloadContinue_TestCountBySentimentAndCompetitor] = React.useState(false);
  const downlodTestCountBySentimentAndCompetitor = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndCompetitor(true)
      const _data = await requests.DownloadTestCountBySentimentAndCompetitor()
      updateIsDownloadContinue_TestCountBySentimentAndCompetitor(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByCompetitorsFunction = async (sourceType: string, date: string, subject: string, tag: string, channelType: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetTestSentimentCountByCompetitors(sourceType, date, subject, tag, channelType, analysisLevel, filterLanguage, filterCountry)
    updateTestSentimentCountByCompetitors(_data);
  }

  const [isDownloadContinue_TestCountBySentimentAndPlatform, updateIsDownloadContinue_TestCountBySentimentAndPlatform] = React.useState(false);
  const downlodTestCountBySentimentAndPlatform = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndPlatform(true)
      const _data = await requests.DownloadTestCountBySentimentAndPlatform()
      updateIsDownloadContinue_TestCountBySentimentAndPlatform(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByPlatformsFunction = async (sourceType: string, date: string, subject: string, tag: string, competitor: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetTestSentimentCountByPlatforms(sourceType, date, subject, tag, competitor, analysisLevel, filterLanguage, filterCountry)
    updateTestSentimentCountByPlatforms(_data);
  }

  const [isDownloadContinue_TestCountBySentimentAndCompetitorAndSubject, updateIsDownloadContinue_TestCountBySentimentAndCompetitorAndSubject] = React.useState(false);
  const downlodTestCountBySentimentAndCompetitorAndSubject = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndCompetitorAndSubject(true)
      const _data = await requests.DownloadTestCountBySentimentAndCompetitorAndSubject()
      updateIsDownloadContinue_TestCountBySentimentAndCompetitorAndSubject(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByCompetitorsAndSubjectsFunction = async (sourceType: string, date: string, subject: string, tag: string, minCount: string, channelType: string, competitor: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetTestSentimentCountByCompetitorsAndSubjects(sourceType, date, competitor, channelType, subject, tag, minCount, filterLanguage, filterCountry)
    updateSentimentByCompetitorsAndSubject(_data);
  }

  const [isDownloadContinue_TestCountBySentimentAndMonth, updateIsDownloadContinue_TestCountBySentimentAndMonth] = React.useState(false);
  const downlodTestCountBySentimentAndMonth = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndMonth(true)
      const _data = await requests.DownloadTestCountBySentimentAndMonth()
      updateIsDownloadContinue_TestCountBySentimentAndMonth(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateTestSentimentCountByMonthsFunction = async (sourceType: string, subject: string, tag: string, channelType: string, competitor: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetTestSentimentCountByMonths(sourceType, subject, tag, channelType, competitor, analysisLevel, filterLanguage, filterCountry)
    updateTestSentimentCountByMonths(_data);
  }

  const updateTestSentimentCountByDaysFunction = async (sourceType: string, subject: string, tag: string, channelType: string, competitor: string, analysisLevel: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetTestSentimentCountByDays(sourceType, subject, tag, channelType, competitor, analysisLevel, filterLanguage, filterCountry)
    updateTestSentimentCountByDays(_data);
  }

  const [isDownloadContinue_TestCountBySentimentAndDay, updateIsDownloadContinue_TestCountBySentimentAndDay] = React.useState(false);
  const downlodTestCountBySentimentAndDay = async () => {
    try {
      updateIsDownloadContinue_TestCountBySentimentAndDay(true)
      const _data = await requests.DownloadTestCountBySentimentAndDay()
      updateIsDownloadContinue_TestCountBySentimentAndDay(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateNotificationFunction = async () => {
    const _data = await requests.GetNotifications()
    updateNotification(_data);
  }

  // const updateTokensForWordCloudFunction = async (date: string = LanguageHelp('Last 30 days')) => {
  //   updateTokenForWordCloud([new WordCloudDto]);
  //   const _data = await requests.GetTokenListForWordCloudList(date)
  //   updateTokenForWordCloud(_data);
  // }

  // const updateTokenForTableFunction = async (date: string = LanguageHelp('Last 30 days')) => {
  //   const _data = await requests.GetTokenForTableList(date)
  //   updateTokenForTable(_data);
  // }

  // const [isDownloadContinue_TokensForTable, updateIsDownloadContinue_TokensForTable] = React.useState(false);
  // const downlodTokensForTable = async () => {
  //   try {
  //     updateIsDownloadContinue_TokensForTable(true)
  //     const _data = await requests.DownloadTokensForTable()
  //     updateIsDownloadContinue_TokensForTable(false)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  const updateSubjectSentimentsForWordCloudFunction = async (sourceType: string, date: string, subject: string, tag: string, minCount: string, channelType: string, competitor: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetSubjectSentimentListForWordCloudList(sourceType, date, competitor, channelType, subject, tag, minCount, filterLanguage, filterCountry)
    updateSubjectSentimentForWordCloud(_data);
  }

  const updateSubjectSentimentForTableFunction = async (sourceType: string, date: string, subject: string, tag: string, minCount: string, channelType: string, competitor: string, filterLanguage: string, filterCountry: string) => {
    try {
      const _data = await requests.GetSubjectSentimentForTableList(sourceType, date, competitor, channelType, subject, tag, minCount, filterLanguage, filterCountry)
      updateSubjectSentimentForTable(_data);
    } catch (error) {
      console.error(error)
      updateSubjectSentimentForTable({ ...new TablesWidget14Dto(), totalCount: 0 })
    }
  }

  const [isDownloadContinue_SubjectSentimentsForTable, updateIsDownloadContinue_SubjectSentimentsForTable] = React.useState(false);
  const downlodSubjectSentimentsForTable = async () => {
    try {
      updateIsDownloadContinue_SubjectSentimentsForTable(true)
      const _data = await requests.DownloadSubjectSentimentsForTable()
      updateIsDownloadContinue_SubjectSentimentsForTable(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateSubjectSentimentCompetitionForTableFunction = async (sourceType: string, date: string, subject: string, tag: string, minCount: string, channelType: string, competitor: string, filterLanguage: string, filterCountry: string) => {
    try {
      const _data = await requests.GetSubjectSentimentCompetitionForTableList(sourceType, date, competitor, channelType, subject, tag, minCount, filterLanguage, filterCountry)
      updateSubjectSentimentCompetitionForTable(_data);
    } catch (error) {
      console.error(error)
      updateSubjectSentimentCompetitionForTable({ ...new TablesWidget15Dto(), totalCount: 0 })
    }
  }

  const [isDownloadContinue_SubjectSentimentCompetitionsForTable, updateIsDownloadContinue_SubjectSentimentCompetitionsForTable] = React.useState(false);
  const downlodSubjectSentimentCompetitionsForTable = async () => {
    try {
      updateIsDownloadContinue_SubjectSentimentCompetitionsForTable(true)
      const _data = await requests.DownloadSubjectSentimentCompetitionsForTable()
      updateIsDownloadContinue_SubjectSentimentCompetitionsForTable(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateSubjectGroupSentimentCompetitionForTableFunction = async (sourceType: string, date: string, subject: string, tag: string, minCount: string, channelType: string, competitor: string, filterLanguage: string, filterCountry: string) => {
    try {
      const _data = await requests.GetSubjectGroupSentimentCompetitionForTableList(sourceType, date, competitor, channelType, subject, tag, minCount, filterLanguage, filterCountry)
      updateSubjectGroupSentimentCompetitionForTable(_data);
    } catch (error) {
      console.error(error)
      updateSubjectGroupSentimentCompetitionForTable({ ...new TablesWidget15Dto(), totalCount: 0 })
    }
  }

  const [isDownloadContinue_SubjectGroupSentimentCompetitionsForTable, updateIsDownloadContinue_SubjectGroupSentimentCompetitionsForTable] = React.useState(false);
  const downlodSubjectGroupSentimentCompetitionsForTable = async () => {
    try {
      updateIsDownloadContinue_SubjectGroupSentimentCompetitionsForTable(true)
      const _data = await requests.DownloadSubjectGroupSentimentCompetitionsForTable()
      updateIsDownloadContinue_SubjectGroupSentimentCompetitionsForTable(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateHashtagsForWordCloudFunction = async (sourceType: string, date: string, subject: string, tag: string, minCount: string, channelType: string, competitor: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetHashtagListForWordCloudList(sourceType, date, competitor, channelType, subject, tag, minCount, filterLanguage, filterCountry)
    updateHashtagForWordCloud(_data);
  }

  const updateHashtagForTableFunction = async (sourceType: string, date: string, subject: string, tag: string, minCount: string, channelType: string, competitor: string, filterLanguage: string, filterCountry: string) => {
    const _data = await requests.GetHashtagForTableList(sourceType, date, competitor, channelType, subject, tag, minCount, filterLanguage, filterCountry)
    updateHashtagForTable(_data);
  }

  const [isDownloadContinue_HashtagsForTable, updateIsDownloadContinue_HashtagsForTable] = React.useState(false);
  const downlodHashtagsForTable = async () => {
    try {
      updateIsDownloadContinue_HashtagsForTable(true)
      const _data = await requests.DownloadHashtagsForTable()
      updateIsDownloadContinue_HashtagsForTable(false)
    } catch (error) {
      console.error(error)
    }
  }

  const updateSubjectTreeFunction = async (sourceType: string, date: string, subject: string, tag: string, minCount: string, channelType: string, competitor: string) => {
    const _data = await requests.GetReviewSubjectTreeList(sourceType, date, competitor, channelType, subject, tag, minCount)
    updateSubjectTree(_data);

    updateIsFilterCompleted("true"); // Change this to last function every new report
  }

  const updateCountryMapFunction = async (sourceType: string, date: string, subject: string, tag: string, channelType: string, competitor: string, analysisLevel: string, filterLanguage: string) => {
    const _data = await requests.GetTestSentimentCountByCountries(sourceType, date, subject, tag, competitor, channelType, analysisLevel, filterLanguage)
    updateCountryMapData(_data);
  }

  const updateLanguageBarFunction = async (sourceType: string, date: string, subject: string, tag: string, channelType: string, competitor: string, analysisLevel: string, filterCountry: string) => {
    const _data = await requests.GetTestSentimentCountByLanguages(sourceType, date, subject, tag, competitor, channelType, analysisLevel, filterCountry)
    updateLanguageBarData(_data);
  }

  const updateFilters = async (data: string = LanguageHelp('Last 30 days'), type: string = "date", fromButton: boolean = true) => {
    try {
      updateIsFilterCompleted("false");

      var competitorName = filter_Competitor;
      var channelType = filter_ChannelType;
      var date = filter_Date;
      var subject = filter_Subject;
      var tag = filter_Tag;
      var minCount = filter_MinCount;
      var sourceType = filter_SourceType;
      var analysisLevel = filter_AnalysisLevel;
      var filterLanguage = filter_Language;
      var filterCountry = filter_Country;

      if (type === 'competitor') { updateFilter_Competitor(data); competitorName = data; }
      if (type === 'channelType' || type === 'channeltype') { updateFilter_ChannelType(data); channelType = data; }
      if (type === 'subject') { updateFilter_Subject(data); subject = data; }
      if (type === 'tag') { updateFilter_Tag(data); tag = data; }
      if (type === 'date') { updateFilter_Date(data); date = data; }
      if (type === 'minCount') { updateFilter_MinCount(data); minCount = data; }
      if (type === 'sourceType') { updateFilter_SourceType(data); sourceType = data; }
      if (type === 'analysisLevel') { updateFilter_AnalysisLevel(data); analysisLevel = data; localStorage.setItem("analysisLevel", data) }
      if (type === 'language') { updateFilter_Language(data); filterLanguage = data; }
      if (type === 'country') { updateFilter_Country(data); filterCountry = data; }

      updateAllReports({date, subject, tag, minCount, channelType, competitor: competitorName, sourceType, analysisLevel, filterLanguage, filterCountry});
    } catch (error) {
      console.error(error)
    }
  }
  type ReportFilters = {
    date?: string;
    subject?: string;
    tag?: string;
    minCount?: string;
    channelType?: string;
    competitor?: string;
    sourceType?: string;
    analysisLevel?: string;
    filterLanguage?: string;
    filterCountry?: string;
  };
  const updateAllReports = async ({
    date = LanguageHelp('Last 30 days'),
    subject = LanguageHelp('All Subjects'),
    tag = LanguageHelp('All Tags'),
    minCount = '5',
    channelType = 'All Platforms',
    competitor = LanguageHelp('All Competitors'),
    sourceType = sourceTypeFilterDefaultKey,
    analysisLevel = LanguageHelp('Sharing Based'),
    filterLanguage = '',
    filterCountry = '',
  }: ReportFilters = {}) => {
    try {
      // Initiate charts
      updateCompetitorSentimentDistribution({ ...new CardsWidget17Dto(), ...{ allCount: -1 } });
      updateYourSentimentDistribution({ ...new CardsWidget17Dto(), ...{ allCount: -1 } });
      updateOverallSentimentDistribution({ ...new CardsWidget17Dto(), ...{ allCount: -1 } });
      updateCompetitionVolumeDistribution({ ...new CardsWidget18Dto(), ...{ allCount: -1 } });
      updateChannel({ ...new TablesWidget5Dto(), ...{ totalCount: -1 } });
      updateTestSentimentCountByPlatforms([{ ...new ChartsWidget2Dto(), ...{ firstCount: -1 } }]);
      updateTestSentimentCountByCompetitors([{ ...new ChartsWidget2Dto(), ...{ firstCount: -1 } }]);
      updateSentimentByCompetitorsAndSubject([{ ...new ChartsWidgetBubbleDto(), ...{ firstCount: -1 } }]);
      updateTestSentimentCountByMonths([{ ...new ChartsWidget1Dto(), ...{ firstCount: -1 } }]);
      updateTestSentimentCountByDays([{ ...new ChartsWidgetLineDto(), ...{ firstCount: -1 } }]);
      // updateNotification([new ListsWidget6Dto()]);
      // updateTokenForWordCloud([{ ...new WordCloudDto(), ...{ allCount: -1 } }]);
      // updateTokenForTable(new TablesWidget14Dto());
      updateSubjectSentimentForTable({ ...new TablesWidget14Dto(), ...{ totalCount: -1 } });
      updateSubjectSentimentCompetitionForTable({ ...new TablesWidget15Dto(), ...{ totalCount: -1 } });
      updateSubjectGroupSentimentCompetitionForTable({ ...new TablesWidget15Dto(), ...{ totalCount: -1 } });
      updateHashtagForWordCloud([{ ...new WordCloudDto(), ...{ positiveCount: -1 } }]);
      updateSubjectSentimentForWordCloud([{ ...new WordCloudDto(), ...{ positiveCount: -1 } }]);
      updateSubjectTree([{ ...new ChartsWidgetTreeDto(), ...{ attributes: { ...new AttributesDto(), ...{ totalCount: -1 } } } }]);
      updateCountryMapData([]);
      updateLanguageBarData([]);

      if (isAllFilter(competitor, 'All Competitors')) {
        updateOverallSentimentDistributionFunction(sourceType, date, subject, tag, channelType, analysisLevel, filterLanguage, filterCountry);
        updateYourSentimentDistributionFunction(sourceType, date, subject, tag, channelType, analysisLevel, filterLanguage, filterCountry);
        updateCompetitionVolumeDistributionFunction(sourceType, date, subject, tag, channelType, analysisLevel, filterLanguage, filterCountry);
      } else {
        updateCompetitorSentimentDistributionFunction(sourceType, date, subject, tag, competitor, channelType, analysisLevel, filterLanguage, filterCountry);
      }
      updateChannelFunction(sourceType, date, subject, tag, channelType, competitor, analysisLevel, filterLanguage, filterCountry);
      updateTestSentimentCountByPlatformsFunction(sourceType, date, subject, tag, competitor, analysisLevel, filterLanguage, filterCountry);
      updateTestSentimentCountByCompetitorsFunction(sourceType, date, subject, tag, channelType, analysisLevel, filterLanguage, filterCountry);
      updateTestSentimentCountByCompetitorsAndSubjectsFunction(sourceType, date, subject, tag, minCount, channelType, competitor, filterLanguage, filterCountry);
      updateTestSentimentCountByMonthsFunction(sourceType, subject, tag, channelType, competitor, analysisLevel, filterLanguage, filterCountry);
      updateTestSentimentCountByDaysFunction(sourceType, subject, tag, channelType, competitor, analysisLevel, filterLanguage, filterCountry);
      updateNotificationFunction();
      // updateTokenForTableFunction(LanguageHelp('Last 30 days'));
      updateSubjectSentimentsForWordCloudFunction(sourceType, date, subject, tag, minCount, channelType, competitor, filterLanguage, filterCountry);
      updateSubjectSentimentForTableFunction(sourceType, date, subject, tag, minCount, channelType, competitor, filterLanguage, filterCountry);
      updateSubjectSentimentCompetitionForTableFunction(sourceType, date, subject, tag, minCount, channelType, competitor, filterLanguage, filterCountry);
      updateSubjectGroupSentimentCompetitionForTableFunction(sourceType, date, subject, tag, minCount, channelType, competitor, filterLanguage, filterCountry);
      if (sourceType === 'AccountSharings') {
        updateHashtagsForWordCloudFunction(sourceType, date, subject, tag, minCount, channelType, competitor, filterLanguage, filterCountry);
        updateHashtagForTableFunction(sourceType, date, subject, tag, minCount, channelType, competitor, filterLanguage, filterCountry);
      }
      if (filterCountry === '') {
        await updateCountryMapFunction(sourceType, date, subject, tag, channelType, competitor, analysisLevel, filterLanguage);
      }
      if (filterLanguage === '') {
        await updateLanguageBarFunction(sourceType, date, subject, tag, channelType, competitor, analysisLevel, filterCountry);
      }
      updateSubjectTreeFunction(sourceType, date, subject, tag, minCount, channelType, competitor);
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    let al = localStorage.getItem("analysisLevel") ?? LanguageHelp('Sharing Based');
    updateFilter_AnalysisLevel(al);

    getCompetitorNames();
    getReviewSubjects();
    getReviewTags();
    getReviewSubjectGroups();

    requests.GetReviewDocumentLanguageCountryFilterOptions('review').then((opts) => {
      if (opts.isEnabled) {
        setLanguageOptions(toLanguageOptions(opts.languages));
        setCountryOptions(toCountryOptions(opts.countries));
      }
    }).catch(() => {});

    let auth = authHelper.getAuth()
    let filterDate = auth?.result.membershipType == 0 ? LanguageHelp('All time') : LanguageHelp('Last 30 days');
    updateFilter_Date(filterDate);

    updateAllReports({date: filterDate, analysisLevel: al});
  }, []);

  return (
    <>
      <PageTitle breadcrumbs={[]}>{LanguageHelp('Dashboard')}</PageTitle>
      <div className='card mb-3 mb-xl-5 sticky-filter'>
        <div className='card-header pt-5 pb-0'>
          <div className='card-title align-items-start'>Filtreler:</div>
          <div className='card-toolbar'>
            {isFilterCompleted === "false" &&
              <div className='me-5' style={{ marginTop: '-5px' }}>
                <span className='indicator-progress' style={{ display: 'block' }}>
                  {/* {LanguageHelp('Please wait...')} */}
                  <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
                </span>
              </div>
            }
            <DropdownFilterAnalysisLevel className='me-2 mb-2' functionSubmit={updateFilters} options={[LanguageHelp('Sharing Based'), LanguageHelp('Sentence Based')]} selectedOption={filter_AnalysisLevel} />
            <DropdownFilterSourceType className='me-2 mb-2' functionSubmit={updateFilters} selectedKey={filter_SourceType} selectedOption='' />
            <DropdownFilterCompetitor className='me-2 mb-2' functionSubmit={updateFilters} options={competitors} selectedOption={filter_Competitor} />
            <DropdownFilterChannels className='me-2 mb-2' functionSubmit={updateFilters} selectedChannelType={filter_ChannelType} />
            <DropdownFilterSubject className='me-2 mb-2' functionSubmit={updateFilters} options={reviewSubjects} selectedOption={filter_Subject} />
            {reviewTags.length > 1 && <DropdownFilterTag className='me-2 mb-2' functionSubmit={updateFilters} options={reviewTags} selectedOption={filter_Tag} />}
            <DropdownFilterDate className='me-2 mb-2' functionSubmit={updateFilters} selectedDate={filter_Date} />
            <DropdownFilterMinCount className='me-2 mb-2' functionSubmit={updateFilters} selectedMinCount={filter_MinCount} />
            {languageOptions.length > 0 && <DropdownFilterLanguage className='me-2 mb-2' functionSubmit={updateFilters} options={languageOptions} selectedKey={filter_Language} />}
            {countryOptions.length > 0 && <DropdownFilterCountry className='me-2 mb-2' functionSubmit={updateFilters} options={countryOptions} selectedKey={filter_Country} />}
          </div>
        </div>
      </div>
      {!isAllFilter(filter_Competitor, 'All Competitors') &&
        <div>
          {/* begin::Row */}
          <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
            <div className='col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
              <CardsWidget17
                id='idCompetitorSentimentDistribution'
                className=''
                title={LanguageHelp('Sentiment Distribution')}
                name={LanguageHelp('Total Query')}
                firstText={LanguageHelp('Positive')}
                secondText={LanguageHelp('Negative')}
                thirdText={LanguageHelp('Neutral')}
                symbol=''
                data={competitorSentimentDistribution} />
            </div>
          </div>
          {/* end::Row */}
        </div>
      }

      {isAllFilter(filter_Competitor, 'All Competitors') &&
        <div>
          {/* begin::Row */}
          <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
            <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
              <CardsWidget17
                id='idYourSentimentDistribution'
                className=''
                title={LanguageHelp('Your Sentiment Distribution')}
                name={LanguageHelp('Total Query')}
                firstText={LanguageHelp('Positive')}
                secondText={LanguageHelp('Negative')}
                thirdText={LanguageHelp('Neutral')}
                symbol=''
                data={yourSentimentDistribution} />
            </div>
            <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
              <CardsWidget17
                id='idOverallSentimentDistribution'
                className=''
                title={LanguageHelp('Competitors Sentiment Distribution')}
                name={LanguageHelp('Total Query')}
                firstText={LanguageHelp('Positive')}
                secondText={LanguageHelp('Negative')}
                thirdText={LanguageHelp('Neutral')}
                symbol=''
                data={overallSentimentDistribution} />
            </div>
            <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
              <CardsWidget18
                id='idCompetitionVolumeDistribution'
                className=''
                title={LanguageHelp('Competition Volume Distribution')}
                name={LanguageHelp('Total Query')}
                symbol=''
                height='140px'
                data={competitionVolumeDistribution} />
            </div>
          </div>
          {/* end::Row */}

          {/* begin::Row */}
          <div className='row g-5 g-xl-10 mb-5'>
            <div className='col-xl-6'>
              <ChartsWidget2
                id='sentimentByCompetitors'
                className='mb-5'
                data={sentimentByCompetitors}
                functionDownload={downlodTestCountBySentimentAndCompetitor}
                isDownloadContinue={isDownloadContinue_TestCountBySentimentAndCompetitor}
                texts={[LanguageHelp('Happiness Score')]}
                mainLabel={LanguageHelp('Competition Statistics')}
                sideLabel={LanguageHelp('Happiness Score Compared to Competitors')}
                isHorizontal={true}
                height='325px'
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                ]}
                isCompetitorControl={true} />
            </div>
            <div className='col-xl-6'>
              <ChartsWidget1
                id='sentimentByCompetitors'
                className='mb-5'
                data={sentimentByCompetitors}
                functionDownload={downlodTestCountBySentimentAndCompetitor}
                isDownloadContinue={isDownloadContinue_TestCountBySentimentAndCompetitor}
                texts={[LanguageHelp('Total'), LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
                mainLabel={LanguageHelp('Competition Statistics')}
                sideLabel={LanguageHelp('Sentiment Analysis Compared to Competitors')}
                height='325px'
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                ]}
                isCompetitorControl={true} />
            </div>
          </div>
          {/* end::Row */}
        </div>
      }
      {isAllFilter(filter_ChannelType, 'All Platforms') &&
        <div>

          {/* begin::Row */}
          <div className='row g-5 g-xl-10 mb-5'>
            <div className='col-xl-6'>
              <ChartsWidget2
                id='sentimentByPlatforms'
                className='mb-5'
                data={sentimentByPlatforms}
                functionDownload={downlodTestCountBySentimentAndPlatform}
                isDownloadContinue={isDownloadContinue_TestCountBySentimentAndPlatform}
                texts={[LanguageHelp('Happiness Score')]}
                mainLabel={LanguageHelp('Platform Statistics')}
                sideLabel={LanguageHelp('Happiness Score Compared to Platforms')}
                isHorizontal={true}
                height='325px'
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add platforms and turn on daily data collection from the 'Settings/Channels' page.") },
                ]}
                isCompetitorControl={true} />
            </div>
            <div className='col-xl-6'>
              <ChartsWidget1
                id='sentimentByPlatforms'
                className='mb-5'
                data={sentimentByPlatforms}
                functionDownload={downlodTestCountBySentimentAndPlatform}
                isDownloadContinue={isDownloadContinue_TestCountBySentimentAndPlatform}
                texts={[LanguageHelp('Total'), LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
                mainLabel={LanguageHelp('Platform Statistics')}
                sideLabel={LanguageHelp('Sentiment Analysis Compared to Platforms')}
                height='325px'
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add platforms and turn on daily data collection from the 'Settings/Channels' page.") },
                ]}
                isCompetitorControl={true} />
            </div>
          </div>
          {/* end::Row */}
        </div>
      }

      {filter_Date !== LanguageHelp('Today') &&
        <div>
          {/* begin::Row */}
          <div className='row g-5 g-xl-10 mb-5'>

            <div className='col-xl-6'>
              <ChartsWidget1
                id='sentimentByMonths'
                className='mb-5'
                data={sentimentByMonths}
                functionDownload={downlodTestCountBySentimentAndMonth}
                isDownloadContinue={isDownloadContinue_TestCountBySentimentAndMonth}
                texts={[LanguageHelp('Total'), LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
                mainLabel={LanguageHelp('Monthly Quantities')}
                sideLabel={LanguageHelp('Sentiment in the Last Year')}
                height='325px'
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                ]} />
            </div>
            <div className='col-xl-6'>
              <ChartsWidgetLine
                id='sentimentByDays'
                className='mb-5'
                data={sentimentByDays}
                functionDownload={downlodTestCountBySentimentAndDay}
                isDownloadContinue={isDownloadContinue_TestCountBySentimentAndDay}
                texts={[LanguageHelp('Total'), LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
                mainLabel={LanguageHelp('Daily Quantities')}
                sideLabel={LanguageHelp('Sentiment in the Last Month')}
                height='325px' />
            </div>
          </div>
          {/* end::Row */}
        </div>
      }

      {/* begin::Row */}
      {/* <div className='row g-5 g-xl-10 mb-5'>

        <div className='col-xl-6'>
          <WordCloud
            className='mb-5'
            title={LanguageHelp('Token Sentiment Distribution')}
            name={LanguageHelp('Total Token')}
            functionSubmit={updateTokensForWordCloudFunction}
            functionDownload={downlodTokensForTable}
            isDownloadContinue={isDownloadContinue_TokensForTable}
            words={tokensForWordCloud}
            callbacks={{
              getWordColor: (word: any) => word.positiveCount < word.negativeCount ? "#f1416c" : "#50cd89",
              getWordTooltip: (word: any) => `${word.text} (${LanguageHelp('Positive') + ": " + word.positiveCount + ", " + LanguageHelp('Negative') + ": " + word.negativeCount + ", " + LanguageHelp('Neutral') + ": " + word.neutralCount}) `,
            }}
            height='350px'
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isWaringImageMirror={true} />
        </div>
        <div className='col-xl-6'>
          <TablesWidget14
            className='card h-md-96'
            uniqueKey='tokensForTable'
            tableName={LanguageHelp('Token')}
            datas={tokensForTable}
            functionSubmit={updateTokenForTableFunction}
            functionDownload={downlodTokensForTable}
            isDownloadContinue={isDownloadContinue_TokensForTable}
            mainLabel={LanguageHelp('Token Sentiment Distribution')}
            sideLabel={LanguageHelp('Grand Total')}
            warnings={[
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]} />
        </div>
      </div>*/}
      {/* end::Row */}

      {(filter_Country === '' && countryOptions.length > 0) || (filter_Language === '' && languageOptions.length > 0) ? (
        <div className='row g-5 g-xl-10 mb-5'>
          {filter_Country === '' && countryOptions.length > 0 && (
            <div className={filter_Language === '' && languageOptions.length > 0 ? 'col-xl-6' : 'col-xl-12'}>
              <ChartsWidgetWorldMap
                className='mb-5'
                data={countryMapData}
                mainLabel={LanguageHelp('Country Distribution')}
                sideLabel={LanguageHelp('Drag to pan, scroll to zoom')}
                height='360px'
                onCountrySelect={(countryCode) => updateFilters(countryCode, 'country')}
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                ]}
              />
            </div>
          )}
          {filter_Language === '' && languageOptions.length > 0 && (
            <div className={filter_Country === '' && countryOptions.length > 0 ? 'col-xl-6' : 'col-xl-12'}>
              <ChartsWidgetLanguageBar
                className='mb-5'
                data={languageBarData}
                mainLabel={LanguageHelp('Language Distribution')}
                sideLabel={LanguageHelp('Click a language to filter')}
                height='360px'
                onLanguageSelect={(languageCode) => updateFilters(languageCode, 'language')}
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                ]}
              />
            </div>
          )}
        </div>
      ) : null}

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
          <TablesWidget5
            className='card h-md-100'
            uniqueKey='channels'
            datas={channels}
            filter_Date={filter_Date}
            filter_ChannelType={filter_ChannelType}
            filter_SourceType={filter_SourceType}
            filter_Competitor={filter_Competitor}
            functionDownload={downlodTestSentimentRateByChannels}
            isDownloadContinue={isDownloadContinue_TestSentimentRateByChannels}
            mainLabel={LanguageHelp('Channel Sentiment Table')}
            sideLabel={LanguageHelp('Grand Total')}
            selectedOption={filter_Subject}
            selectedChannelType={filter_ChannelType}
            selectedDate={filter_Date}
            warnings={[
              { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]} />
        </div>
      </div>


      {/* end::Row */}
      {filter_SourceType === 'AccountSharings' &&
        <div>
          {/* begin::Row */}
          <div className='row g-5 g-xl-10 mb-5'>

            <div className='col-xl-12'>
              <WordCloud
                className=''
                mainLabel={LanguageHelp('Hashtag Cloud')}
                // sideLabel={LanguageHelp('Total Count')}
                functionDownload={downlodHashtagsForTable}
                isDownloadContinue={isDownloadContinue_HashtagsForTable}
                data={hashtagsForWordCloud}
                callbacks={{
                  getWordColor: (word: any) => getColorCodeFromDivision(word.positiveCount, word.negativeCount),
                  getWordTooltip: (word: any) => `${word.text} (${LanguageHelp('Positive') + ": " + word.positiveCount + ", " + LanguageHelp('Negative') + ": " + word.negativeCount + ", " + LanguageHelp('Neutral') + ": " + word.neutralCount}) `,
                }}
                height='450px'
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                ]}
                isWaringImageMirror={true} />
            </div>
            <div className='col-xl-12'>
              <TablesWidget14
                className='card h-md-96'
                uniqueKey='subjectSentimentsForTable'
                tableName={LanguageHelp('Subject')}
                datas={hashtagsForTable}
                columnCount={6}
                header1={LanguageHelp('Total')}
                header2={LanguageHelp('View')}
                header3={LanguageHelp('Like')}
                header4={LanguageHelp('Dislike')}
                header5={LanguageHelp('Comment')}
                header6={LanguageHelp('Sharing')}
                filter_Date={filter_Date}
                filter_ChannelType={filter_ChannelType}
                filter_SourceType={filter_SourceType}
                filter_Competitor={filter_Competitor}
                functionDownload={downlodHashtagsForTable}
                isDownloadContinue={isDownloadContinue_HashtagsForTable}
                url={'/apps/artificial-intelligence/overview?'}
                mainLabel={LanguageHelp('Hashtag Table')}
                // sideLabel={LanguageHelp('Grand Total')}
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                ]} />
            </div>
          </div>
          {/* end::Row */}
        </div>
      }

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5'>
        <div className='col-xl-12'>
          <ChartsWidgetBubble
            id='sentimentByCompetitorsAndSubjects'
            className='mb-5'
            data={sentimentByCompetitorsAndSubjects}
            functionDownload={downlodTestCountBySentimentAndCompetitorAndSubject}
            isDownloadContinue={isDownloadContinue_TestCountBySentimentAndCompetitorAndSubject}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Subject Sentiment Competition Cloud') + (filter_AnalysisLevel !== LanguageHelp('Sentence Based') ? ' - ' + LanguageHelp('Sentence Based') : '')}
            // sideLabel={LanguageHelp('Grand Total')}
            height='550px'
            isCompetitorControl={true}
            warnings={[
              { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isWaringImageMirror={true} />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      {isAllFilter(filter_Subject, 'All Subjects') && isAllFilter(filter_Competitor, 'All Competitors') &&
        <div>
          {/* begin::Row */}
          {reviewSubjectGroups.length > 1 &&
            <div className='row g-5 g-xl-10 mb-5'>
              <div className='col-xl-12'>
                <TablesWidget15
                  className='card h-md-96'
                  uniqueKey='subjectGroupCompetitionsForTable'
                  tableName={LanguageHelp('Subject Group')}
                  datas={subjectGroupSentimentCompetitionsForTable}
                  columnCount={4}
                  header1={LanguageHelp('Total')}
                  header2={LanguageHelp('Positive')}
                  header3={LanguageHelp('Negative')}
                  header4={LanguageHelp('Neutral')}
                  header5={LanguageHelp('')}
                  header6={LanguageHelp('')}
                  filter_Date={filter_Date}
                  filter_ChannelType={filter_ChannelType}
                  filter_SourceType={filter_SourceType}
                  functionDownload={downlodSubjectGroupSentimentCompetitionsForTable}
                  isDownloadContinue={isDownloadContinue_SubjectGroupSentimentCompetitionsForTable}
                  url={'/apps/artificial-intelligence/overview?'}
                  mainLabel={LanguageHelp('Subject Group Sentiment Competition Table') + (filter_AnalysisLevel !== LanguageHelp('Sentence Based') ? ' - ' + LanguageHelp('Sentence Based') : '')}
                  // sideLabel={LanguageHelp('Grand Total')}
                  warnings={[
                    { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                    { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subject groups from the 'Artificial Intelligence/Subject Groups page.") },
                    { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                  ]} />
              </div>
            </div>
          }
          {/* end::Row */}
          {/* begin::Row */}
          <div className='row g-5 g-xl-10 mb-5'>
            <div className='col-xl-12'>
              <TablesWidget15
                className='card h-md-96'
                uniqueKey='subjectCompetitionsForTable'
                tableName={LanguageHelp('Subject')}
                datas={subjectSentimentCompetitionsForTable}
                columnCount={4}
                header1={LanguageHelp('Total')}
                header2={LanguageHelp('Positive')}
                header3={LanguageHelp('Negative')}
                header4={LanguageHelp('Neutral')}
                header5={LanguageHelp('')}
                header6={LanguageHelp('')}
                filter_Date={filter_Date}
                filter_ChannelType={filter_ChannelType}
                filter_SourceType={filter_SourceType}
                functionDownload={downlodSubjectSentimentCompetitionsForTable}
                isDownloadContinue={isDownloadContinue_SubjectSentimentCompetitionsForTable}
                url={'/apps/artificial-intelligence/overview?'}
                mainLabel={LanguageHelp('Subject Sentiment Competition Table') + (filter_AnalysisLevel !== LanguageHelp('Sentence Based') ? ' - ' + LanguageHelp('Sentence Based') : '')}
                // sideLabel={LanguageHelp('Grand Total')}
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                ]} />
            </div>
          </div>
          {/* end::Row */}
        </div>
      }
      {/* end::Row */}

      {/* begin::Row */}
      {isAllFilter(filter_Subject, 'All Subjects') &&
        <div>
          {/* begin::Row */}
          <div className='row g-5 g-xl-10 mb-5'>

            <div className='col-xl-12'>
              <WordCloud
                className=''
                mainLabel={LanguageHelp('Subject Sentiment Cloud') + (filter_AnalysisLevel !== LanguageHelp('Sentence Based') ? ' - ' + LanguageHelp('Sentence Based') : '')}
                // sideLabel={LanguageHelp('Total Count')}
                functionDownload={downlodSubjectSentimentsForTable}
                isDownloadContinue={isDownloadContinue_SubjectSentimentsForTable}
                data={subjectSentimentsForWordCloud}
                callbacks={{
                  getWordColor: (word: any) => getColorCodeFromDivision(word.positiveCount, word.negativeCount),
                  getWordTooltip: (word: any) => `${word.text} (${LanguageHelp('Positive') + ": " + word.positiveCount + ", " + LanguageHelp('Negative') + ": " + word.negativeCount + ", " + LanguageHelp('Neutral') + ": " + word.neutralCount}) `,
                }}
                height='450px'
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                ]}
                isWaringImageMirror={true} />
            </div>
            <div className='col-xl-12'>
              <TablesWidget14
                className='card h-md-96'
                uniqueKey='subjectSentimentsForTable'
                tableName={LanguageHelp('Subject')}
                datas={subjectSentimentsForTable}
                columnCount={4}
                header1={LanguageHelp('Total')}
                header2={LanguageHelp('Positive')}
                header3={LanguageHelp('Negative')}
                header4={LanguageHelp('Neutral')}
                header5={LanguageHelp('')}
                header6={LanguageHelp('')}
                filter_Date={filter_Date}
                filter_ChannelType={filter_ChannelType}
                filter_SourceType={filter_SourceType}
                filter_Competitor={filter_Competitor}
                functionDownload={downlodSubjectSentimentsForTable}
                isDownloadContinue={isDownloadContinue_SubjectSentimentsForTable}
                url={'/apps/artificial-intelligence/overview?'}
                mainLabel={LanguageHelp('Subject Sentiment Table') + (filter_AnalysisLevel !== LanguageHelp('Sentence Based') ? ' - ' + LanguageHelp('Sentence Based') : '')}
                // sideLabel={LanguageHelp('Grand Total')}
                warnings={[
                  { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
                  { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
                  { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
                ]} />
            </div>
          </div>
          {/* end::Row */}
        </div>
      }
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5'>
        <div className='col-xl-12'>
          <ChartsWidgetTree
            id='subjectTree'
            className='mb-5'
            data={subjectTree}
            // functionDownload={downlodSubjectTree}
            // isDownloadContinue={isDownloadContinue_SubjectTree}
            texts={[LanguageHelp('Positive'), LanguageHelp('Negative'), LanguageHelp('Neutral')]}
            mainLabel={LanguageHelp('Subject Sentiment Tree') + (filter_AnalysisLevel !== LanguageHelp('Sentence Based') ? ' - ' + LanguageHelp('Sentence Based') : '')}
            // sideLabel={LanguageHelp('Grand Total')}
            options={reviewSubjects}
            height='550px'
            filter_Date={filter_Date}
            filter_ChannelType={filter_ChannelType}
            filter_SourceType={filter_SourceType}
            filter_Competitor={filter_Competitor}
            // isCompetitorControl={true}
            warnings={[
              { url: '/dashboard', message: LanguageHelp("No data was found matching the criteria you selected.") },
              { url: '/apps/artificial-intelligence/subjects', message: LanguageHelp("You can add subjects from the 'Artificial Intelligence/Subjects page.") },
              { url: '/crafted/channels', message: LanguageHelp("You can add competitors and turn on daily data collection from the 'Settings/Channels' page.") },
            ]}
            isWaringImageMirror={true}
          />
        </div>
      </div>
      {/* end::Row */}

    </>
  )
}

export { DashboardWrapper }
